import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b9c3b9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-details" }
const _hoisted_2 = { class: "data-field" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Erstellt", -1))
const _hoisted_4 = { class: "data-field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Gesendet", -1))
const _hoisted_6 = { class: "data-field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Verarbeitet", -1))
const _hoisted_8 = { class: "data-field" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Zugestellt", -1))
const _hoisted_10 = { class: "data-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Gelesen", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "data-field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Autor", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_alert = _resolveComponent("md-alert")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_modal = _resolveComponent("md-modal")!

  return (_openBlock(), _createBlock(_component_md_modal, {
    ref: "modal",
    title: "Details dieser Nachricht",
    icon: "message"
  }, {
    default: _withCtx(() => [
      _createTextVNode(" Hier werden dir alle Details zu dieser Nachricht angezeigt. ")
    ]),
    body: _withCtx(() => [
      (_ctx.message.state === 'failed')
        ? (_openBlock(), _createBlock(_component_md_alert, {
            key: 0,
            variant: "error",
            icon: "warning",
            style: {"margin-bottom":"20px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Diese Nachricht wurde nicht gesendet. ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("b", null, _toDisplayString(_ctx.message.created ? _ctx.formatDate(_ctx.message.created.toDate()) : "/"), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("b", null, _toDisplayString(_ctx.message.sent ? _ctx.formatDate(_ctx.message.sent.toDate()) : "/"), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("b", null, _toDisplayString(_ctx.message.processed ? _ctx.formatDate(_ctx.message.processed.toDate()) : "/"), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("b", null, _toDisplayString(_ctx.message.received ? _ctx.formatDate(_ctx.message.received.toDate()) : "/"), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("b", null, _toDisplayString(_ctx.message.read ? _ctx.formatDate(_ctx.message.read.toDate()) : "/"), 1)
        ]),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("b", null, _toDisplayString(_ctx.message.operator ? _ctx.message.operator.email : "Keine Angaben"), 1)
        ])
      ]),
      (_ctx.message.sender === 'user')
        ? (_openBlock(), _createBlock(_component_md_alert, {
            key: 1,
            variant: "info",
            style: {"margin-top":"20px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Für eingehende Nachrichten stehen nur eingeschränkte Informationen zur Verfügung. Es wird kein \"gelesen\" Status an den Sender übermittelt, wenn du Nachrichten liest. ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_md_button, {
        variant: "text",
        grey: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Schließen")
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}